export default async function FixedAside() {
  const buttonAside = document.querySelector('.fixed-aside');
  const fixedBox = document.querySelector('.fixed-box');
  const body = document.querySelector('body');

  // открытие popUp по нажатию
  if (buttonAside) {
    buttonAside.addEventListener('click', () => {

    if(body.classList.contains('fixed-aside_open')) {
      body.classList.remove('fixed-aside_open');
      body.classList.remove('no-scroll');
    } else {
      body.classList.add('fixed-aside_open');
      body.classList.add('no-scroll');
      // отправляем событие в GTM
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'GoalEvent',
          eventCategoryUA: 'widgetLink',
          eventActionUA: 'click',
          eventGoalYM: 'widgetLink_click',
          eventGA4: 'widgetLink_click',
        });
      }
    }

    });
  }

  // закрытие popUp по нажатию
  const closeBox = document.querySelector('.close-fixed-box');
  if (closeBox) {
    closeBox.addEventListener('click', () => {

    });
  }

  // клик по значку "позвонить"
  const phoneLink = fixedBox.querySelector('.js-call-only-mobile');
  if (phoneLink) {
    phoneLink.addEventListener('click', () => {
      // отправляем событие в GTM
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'GoalEvent',
          eventCategoryUA: 'widgetLink',
          eventActionUA: 'click',
          eventGoalYM: 'widgetPhoneLink_click',
          eventGA4: 'widgetPhoneLink_click',
        });
      }
    });
  }

  // клик по значку "задать вопрос"
  const askLink = fixedBox.querySelector('.js-ask-question');
  if (askLink) {
    askLink.addEventListener('click', () => {
      // отправляем событие в GTM
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'GoalEvent',
          eventCategoryUA: 'widgetQuestionLink',
          eventActionUA: 'click',
          eventGoalYM: 'widgetQuestionLink_click',
          eventGA4: 'widgetQuestionLink_click',
        });
      }
    });
  }

  // клик по значку "заказать звонок"
  const callbackLink = fixedBox.querySelector('.js-request-callback');
  if (callbackLink) {
    callbackLink.addEventListener('click', () => {
      // отправляем событие в GTM
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'GoalEvent',
          eventCategoryUA: 'widgetCallbackLink',
          eventActionUA: 'click',
          eventGoalYM: 'widgetCallbackLink_click',
          eventGA4: 'widgetCallbackLink_click',
        });
      }
    });
  }

  // клик по значку "заказать звонок"
  const appointmentLink = fixedBox.querySelector('.js-widget-appointment');
  if (appointmentLink) {
    appointmentLink.addEventListener('click', () => {
      // используем уникальную переменную чтобы передать данные в fancybox
      window.forFancyBox3715601438 = 'js-from-widget';

      // отправляем событие в GTM
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'GoalEvent',
          eventCategoryUA: 'widgetAppointmentLink',
          eventActionUA: 'click',
          eventGoalYM: 'widgetAppointmentLink_click',
          eventGA4: 'widgetAppointmentLink_click',
        });
      }
    });
  }

  // открывание живосайта вместо ссылки, в мобилке
  const popapElement = document.querySelector('.popap-open-mobile');
  if (popapElement) {
    popapElement.addEventListener('click', (e) => {
      if (window.innerWidth < 1024 && location.hostname !== 'msk.excimerclinic.ru') {
        e.preventDefault();
        jivo_api.open();
      }
    });
  }

  // смена иконок
  const images = ['/assets/new/img/aside_b2.svg', '/assets/new/img/aside_b1.svg'];
  let index = 1;
  let lastIndex = 0;

  const action = () => {
    if (index === images.length) {
      lastIndex = images.length - 1;
      index = 0;
    }
    const message = document.querySelector('.fixed-aside .fixed-aside-opens');
    const { children } = message;
    changeDisplayStyle(children[index], 1);
    changeDisplayStyle(children[lastIndex], 0);

    lastIndex = index;
    index += 1;
  };
  action();
  setInterval(action, 5000);

  const messageCounts = document.querySelectorAll('.fixed-aside-opens');
  if (messageCounts) {
    messageCounts.forEach((mes) => {
      setTimeout(() => mes.classList.add('message-vision'), 20000);
    });
  }
}

/**
 *
 * @param {Element} el
 * @param state
 */
function changeDisplayStyle(el, state) {
  if (state === 1) {
    el.style.display = 'block';
  } else {
    el.style.display = 'none';
  }
}
